<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <div class="vx-row" v-if="item.id">
            
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="Edit Product">

                    <div class="vx-row mb-3">
                        <h2 class="vx-col w-full text-primary">
                            {{item.title}} - {{formatPrice(item.cost)}}
                        </h2>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-2/5">
                            <label for="iddd">
                                Require Locations ?
                                <vs-switch v-model="item.locations" id="iddd" label="helo" />
                            </label>
                        </div>
                        <div class="vx-col w-2/5">
                            <label for="asdf">
                                Product Status: 
                                <span :class="`text-${item.active ? 'primary' : 'danger'}`">{{item.active ? 'Active' : 'Inactive'}}</span>
                                <vs-switch v-model="item.active" id="asdf" label="helo" />
                            </label>
                        </div>
                        
                    </div>
                    <div class="vx-row my-5 pl-4" v-if="!item.active">
                        <div class="vx-col w-4/5 bg-danger text-white rounded">
                            <em>This product is currently inactive. Which means this product cannot be purchased or used at the moment.</em>
                        </div>
                    </div>
                    <div class="my-4" style="border-bottom:1px solid #ccc"></div>
                    <div class="vx-row">
                        <div class="vx-col w-3/5">
                            <vs-input class="w-full mb-4" v-model="item.title" label="Name" />
                        </div>
                        
                    </div>
                    <vs-input type="number" class="w-full mb-4" v-model="item.cost" label="Price"  style="max-width:100px;" />
                    <vs-input type="text" class="w-full mb-4" v-model="item.costCode" label="Cost Item"  style="max-width:200px;" />
                    <vs-input type="text" class="w-full mb-4" v-model="item.costType" label="Cost Type"  style="max-width:200px;" />

                    <vs-button class="mr-4" @click="save">Update</vs-button>

                </vx-card>
            </div>

        

        </div>

        
        
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {formatPrice} from '@/assets/helper'
export default{
    
    data() {
        return {
            item:{

            },
            origItem:{}
        }
    },
    methods:{
        formatPrice,
        async save(){

            this.$update(`/products/${this.item.id}`, this.item).then( ({data}) => {
                
                this.$store.commit('SET_PROP', {where:['products',data.id],what:data})

                this.$vs.notify({
                    title: 'Success',
                    text: 'Product updated successfully',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position:'bottom-center'
                })
                this.$router.push({path:'/products'})
            }).catch( err => {
                
            })
                

        }
    },
  
    created(){
        let id = this.$route.params.id
        this.item = JSON.parse(JSON.stringify(this.$store.state.products[id]))

    },
    mounted() {
        console.log('HELLO MELLO ', this.$route.params)
       
    }
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>
